<template>
  <v-col cols="12">
    <div
      class="d-flex commentsBox"
      :class="{
        'highlight': highlightComment
      }"
    >
      <v-avatar size="36">
        <v-img :src="avatarUrl(picture)"></v-img>
      </v-avatar>
      <div class="commentShow ml-3 mb-2 px-3 py-1">
        <div class="d-flex align-center">
          <b>{{ name }}</b>
          <v-icon size="4px" class="mx-2">fas fa-circle</v-icon>
          <span>{{ createdDate | ago }}</span>
        </div>
        <v-textarea
          v-if="edit"
          rows="1"
          auto-grow
          class="mb-2"
          v-model="content"
          :append-icon="'fas fa-paper-plane'"
          :placeholder="$gettext('Enter comment')"
          hide-details="auto"
          solo
          flat
          dense
          @keydown.enter.exact.prevent="updateComment"
          @click:append.prevent="updateComment"
        />
        <p class="mb-0 font-italic grey--text" v-else-if="deleted" v-translate>This comment was deleted from this post</p>
        <p class="mb-0" v-else>{{ text }}</p>
      </div>
    </div>
  </v-col>
</template>
<script>
export default {
  props: {
    id: {},
    parent: {},
    picture: {},
    name: {},
    text: {},
    createdDate: {},
    edit: {
      type: Boolean,
      default: false,
    },
    deleted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      content: "",
    };
  },
  watch: {
    text: {
      immediate: true,
      handler(val) {
        this.content = val;
      },
    },
  },
  methods: {
    updateComment() {
      let vm = this;
      vm.$emit("updateComment", {
        id: vm.id,
        parent: vm.parent,
        text: vm.content,
      });
    },
  },
  computed: {
    highlightComment() {
      if(!this.$route.params.commentId) return false
      return this.id === parseInt(this.$route.params.commentId)
    }
  }
};
</script>